<div class="fe-pro-tips" [ngClass]="{'fe-pt-black' : color === 'DEFAULT',
'fe-pt-blue' : color === 'PRIMARY', 'fe-pt-red' : color === 'DANGER', 'fe-pt-hide': hidePt}">
    <span class="title">{{title}}</span>
    <span class="text">{{text}}</span>
<!--    <fe-button *ngIf="dismissButton" [color]="color" type="TERTIARY" text="Ne plus afficher" (click)="hidePt = true;"-->
<!--    bold="true"/>-->
</div>
